import { Grid, H, P } from '@farewill/ui'
import { useFormikContext } from 'formik'

import InputFloating from 'components/form/input-floating'
import { BRAND_ID } from 'config/brands'
import { SaveProp } from './types'

const InternalNotes = ({ handleSave }: { handleSave: SaveProp }) => {
  const {
    values: {
      contact: { brandId },
    },
  } = useFormikContext<{ contact: { brandId: string } }>()
  const isFarewillBrand = brandId === BRAND_ID.farewill

  return (
    <Grid>
      <Grid.Item>
        <H size="M">{`${isFarewillBrand ? '8. ' : '7. '}Internal notes`}</H>
        <P>General notes about the fact find from our team</P>
      </Grid.Item>
      <Grid.Item>
        <InputFloating
          name="internalNotes"
          label="Notes"
          component="textarea"
          handleSave={handleSave}
        />
      </Grid.Item>
    </Grid>
  )
}

export default InternalNotes
